var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13276 8.20856C3.13276 8.20856 5.0747 10.4053 6.33159 11.8272C6.72882 12.2768 7.30022 12.5342 7.90042 12.5342C8.50062 12.5342 9.07201 12.2768 9.46947 11.8272L12.6632 8.21436C12.9182 7.92588 12.8907 7.48501 12.6022 7.23022C12.3135 6.97543 11.8721 7.00287 11.6173 7.29113L8.42358 10.904C8.29095 11.0539 8.10048 11.1398 7.90042 11.1398C7.70035 11.1398 7.50989 11.0539 7.37748 10.904C6.12058 9.48207 4.17864 7.28533 4.17864 7.28533C3.92365 6.99684 3.48243 6.96962 3.19372 7.22442C2.905 7.47921 2.87776 7.92008 3.13276 8.20856Z",
    fill: "#566F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.221436 9.41206V13.5954C0.221659 14.7507 1.1588 15.6871 2.31499 15.6871H13.4794C14.6356 15.6871 15.5728 14.7507 15.5728 13.5954V9.41206C15.5728 9.0272 15.2601 8.71484 14.875 8.71484C14.4898 8.71484 14.1772 9.0272 14.1772 9.41206V13.5954C14.1772 13.9805 13.8648 14.2926 13.4794 14.2926H2.31499C1.92959 14.2926 1.61721 13.9805 1.61699 13.5954V9.41206C1.61699 9.0272 1.30439 8.71484 0.919213 8.71484C0.534263 8.71484 0.221436 9.0272 0.221436 9.41206Z",
    fill: "#566F8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19971 0.696998V11.8528C7.19971 12.2374 7.51231 12.55 7.89748 12.55C8.28266 12.5498 8.59526 12.2374 8.59526 11.8525V0.697221C8.59526 0.312355 8.28266 1.19364e-07 7.89748 1.19364e-07C7.51231 -0.000222991 7.19971 0.312355 7.19971 0.696998Z",
    fill: "#566F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b6bba6a8cb4cb32e2c0ad19685a06377.svg";
export { ForwardRef as ReactComponent };